import { render, staticRenderFns } from "./VerTodasIndicaciones.vue?vue&type=template&id=00040495&scoped=true"
import script from "./VerTodasIndicaciones.vue?vue&type=script&lang=js"
export * from "./VerTodasIndicaciones.vue?vue&type=script&lang=js"
import style0 from "./VerTodasIndicaciones.vue?vue&type=style&index=0&id=00040495&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00040495",
  null
  
)

export default component.exports